module.exports = __webpack_public_path__ + "static/media/9.a2520186.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/9.png
// module id = 965
// module chunks = 0